import Vue from 'vue'
import Vuex from 'vuex'
import utils from 'js/bankrate-utilities'
import moment from 'moment'
import { forEach, assign, some } from 'lodash'
import calculatorEventBus from 'apps/bankrate-calculators/events'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: utils.isMobile(),
    // inputs
    savingsGoal: '',
    yearsToSave: '',
    interestRate: '',
    compoundingOption: '',
    firstDeposit: '',
    skip2WeeksOption: '',
    startDate: moment().format('MM/DD/YYYY'),
    errors: {
      savingsGoal: false,
      yearsToSave: false,
      interestRate: false,
      compoundingOption: false,
      firstDeposit: false,
      skip2WeeksOption: false,
      startDate: false
    },
    previousUserInputs: {
      savingsGoal: '',
      yearsToSave: '',
      interestRate: '',
      compoundingOption: '',
      firstDeposit: '',
      skip2WeeksOption: '',
      startDate: moment().format('MM/DD/YYYY')
    }
  },
  mutations: {
    updatePageState(state, payload) {
      state[payload.name] = payload.value
    },
    updatePreviousUserInputState(state) {
      forEach(state.previousUserInputs, (value, key) => {
        state.previousUserInputs[key] = state[key]
      })
    },
    setPageErrors(state, payload) {
      const error = payload.error === undefined ? false : payload.error
      state.errors = assign(state.errors, { [payload.name]: error })
    }
  },
  actions: {
    loadDefaultState({ state, dispatch }, config) {
      forEach(state, (value, key) => {
        if (config[key] !== undefined && config[key].default !== undefined) {
          dispatch('setState', {
            name: key,
            value: config[key].default,
            error: false
          })
        }
      })
    },
    setState({ commit }, payload) {
      commit('updatePageState', { name: payload.name, value: payload.value })
      commit('setPageErrors', { name: payload.name, error: payload.error })
    },
    setNumberValue({ commit }, payload) {
      commit('updatePageState', { name: payload.name, value: payload.value })
      commit('setPageErrors', { name: payload.name, error: payload.error })
    },
    setCurrencyValue({ commit }, payload) {
      const value = isNaN(payload.value)
        ? 0
        : Math.round(payload.value * 100) / 100
      commit('updatePageState', { name: payload.name, value: value })
      commit('setPageErrors', { name: payload.name, error: payload.error })
    },
    setDateValue({ commit }, payload) {
      commit('updatePageState', { name: payload.name, value: payload.value })
      commit('setPageErrors', { name: 'startDate', error: payload.error })
    },
    setSavingsGoal({ state, dispatch }, payload) {
      dispatch('setCurrencyValue', payload)
      dispatch('setCurrencyValue', {
        name: 'firstDeposit',
        value: state.firstDeposit,
        error: state.savingsGoal < state.firstDeposit
      })
      calculatorEventBus.$emit('savingGoalChanged')
    },
    updatePreviousUserInputs({ commit }) {
      commit('updatePreviousUserInputState')
    }
  },
  getters: {
    errorsOnPage(state) {
      return some(state.errors, item => {
        return item
      })
    },
    dataChanged(state) {
      return some(state.previousUserInputs, (input, key) => {
        return input !== state[key]
      })
    },
    computedFirstDepositMax(state) {
      return state.savingsGoal > 0
        ? Math.round(state.savingsGoal * 100) / 100
        : 100
    },
    startDate(state) {
      return moment(state.startDate, 'MM/DD/YYYY')
    }
  }
})
